module.exports = __webpack_public_path__ + "static/media/ico-grid.e6eba52b.svg";